













import {Component, Vue} from "vue-property-decorator";

@Component
export default class ChangeLang extends Vue {
  private refreshkey: number = 0;

  get dropDownKey (): string{
    return `lang-${this.refreshkey}`;
  }

  selectSK(){
    this.$root.$i18n.locale = 'sk';
    this.refreshkey += 1;
  }
  selectEN(){
    this.$root.$i18n.locale = 'en';
    this.refreshkey += 1;
  }

}
